// @ts-strict-ignore
import type { TextObject } from "types/contentful";
import type { TypographyObjectProps } from "./typographyObject";
import {
  contentfulTypograpyObjectToTypography,
  typographyObjectDefaults
} from "./typographyObject";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

export interface TextObjectProps {
  id: string;
  text: string;
  markdown: string;
  as: string;
  size: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
  variant: "Heading" | "Display" | "Body";
  bold: boolean;
  marketingTypeset: boolean;
  typography: TypographyObjectProps;
}

export const textObjectDefaults: TextObjectProps = {
  id: "",
  text: "",
  markdown: "",
  as: "",
  size: "md",
  variant: "Body",
  bold: false,
  marketingTypeset: false,
  typography: cloneDeep(typographyObjectDefaults)
};

export const contentfulTextObjectToText = (
  contentfulObject: TextObject,
  country = ""
): TextObjectProps => {
  const mobile = contentfulTypograpyObjectToTypography(
    contentfulObject?.fields?.mobileTypography,
    "mobile"
  );
  const tablet = contentfulTypograpyObjectToTypography(
    contentfulObject?.fields?.tabletTypography,
    "tablet"
  );
  const desktop = contentfulTypograpyObjectToTypography(
    contentfulObject?.fields?.desktopTypography,
    "desktop"
  );
  const typography =
    (merge(mobile, tablet, desktop) as TypographyObjectProps) ||
    textObjectDefaults.typography;
  const overrideText = contentfulObject?.fields?.countryOverride?.filter(
    (override) => override?.fields?.country === country
  )?.[0];
  // prioritize overrides if they exist
  if (Boolean(overrideText)) {
    return {
      id: overrideText?.fields?.idReference || textObjectDefaults.id,
      text: overrideText?.fields?.text || textObjectDefaults.text,
      markdown: overrideText?.fields?.markdown || textObjectDefaults.markdown,
      as: overrideText?.fields?.as || textObjectDefaults.as,
      size: overrideText?.fields?.size || textObjectDefaults.size,
      variant: overrideText?.fields?.variant || textObjectDefaults.variant,
      bold: overrideText?.fields?.bold || textObjectDefaults.bold,
      marketingTypeset:
        overrideText?.fields?.marketingTypeset ||
        textObjectDefaults.marketingTypeset,
      typography
    };
  }
  return {
    id: contentfulObject?.fields?.idReference || textObjectDefaults.id,
    text: contentfulObject?.fields?.text || textObjectDefaults.text,
    markdown: contentfulObject?.fields?.markdown || textObjectDefaults.markdown,
    as: contentfulObject?.fields?.as || textObjectDefaults.as,
    size: contentfulObject?.fields?.size || textObjectDefaults.size,
    variant: contentfulObject?.fields?.variant || textObjectDefaults.variant,
    bold: contentfulObject?.fields?.bold || textObjectDefaults.bold,
    marketingTypeset:
      contentfulObject?.fields?.marketingTypeset ||
      textObjectDefaults.marketingTypeset,
    typography
  };
};
